const headers = {
    authorization: 'Bearer ' + localStorage.getItem('token'),
    contentType: 'application/json'
}

export default headers;